import { render } from "./PassengerListCard.vue?vue&type=template&id=5d3fe02e&scoped=true"
import script from "./PassengerListCard.vue?vue&type=script&lang=js"
export * from "./PassengerListCard.vue?vue&type=script&lang=js"

import "./PassengerListCard.vue?vue&type=style&index=0&id=5d3fe02e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3fe02e"]])

export default __exports__